import Button from '@doordash/component-button'
import NavBar from '@doordash/component-navbar'
import Pagination from '@doordash/component-pagination'
import { Text, StackChildren } from '@doordash/design-language'
import { get, has, noop } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactSwipe from 'react-swipe'
import * as actions from '../../../actions'
import {
  ANDROID_CLOSE_DEEPLINK,
  COUNTRY_SHORTCODES,
  DD_READY_FIRST_DASH_TS,
  INSTANT_DASH_SPLASH_SUB,
  IOS_CLOSE_DEEPLINK,
} from '../../../constants'
import * as events from '../../../events'
import routes from '../../../routes'
import { EventActions } from '../../../typeModules/events'
import {
  Direction,
  Slide as SlideType,
  SlideButtons,
  SlideDecks,
} from '../../../typeModules/slide'
import SimpleStore from '../../../utilities/SimpleStore'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import LinkButton from '../../atoms/link-button'
import s from './strings'
import { Bottom, Slide, SlideWrapper, Wrapper } from './styles'

type Props = {
  slides: SlideType[]
  deck: SlideDecks
  application?: object
  experiments?: any
  trackInAppEducationNavigated?: (any) => Promise<any>
  closeInAppEducation?: (any) => Promise<any>
  trackWebviewClosed?: () => Promise<any>
}

export class InAppEducation extends React.Component<Props> {
  public static defaultProps = {
    trackInAppEducationNavigated: console.log,
    closeInAppEducation: console.log,
    trackWebviewClosed: console.log,
  }

  public state = {
    index: 0,
  }

  private reactSwipeEl: any
  private clicked: boolean = false

  public componentDidMount() {
    this.props.trackInAppEducationNavigated({
      deck: this.props.deck,
      action: EventActions.Rendered,
    })
    // accounting for first slide's tracking
    this.onSwiped(0)
  }

  public render() {
    const { index } = this.state
    const {
      slides,
      experiments,
      closeInAppEducation,
      application,
      trackWebviewClosed,
      trackInAppEducationNavigated,
      deck,
    } = this.props
    const currentSlide = slides[index]

    const os = detectWebviewOs()
    const uniqueLink = get(application, 'uniqueLink')
    const country = get(application, 'country')

    let count = 0
    slides.map(slide => {
      if (slide.showPagination) {
        count += 1
      }
    })

    return (
      <Wrapper isFullScreen={has(currentSlide, 'raw')}>
        {currentSlide.showBackButton && (
          <NavBar
            navigationType={NavBar.NavigationTypes.Back}
            isSeparatorVisible={false}
            onOverflowClick={noop}
            onNavigationClick={() => {
              this.clicked = true
              this.reactSwipeEl.prev()
            }}
          />
        )}
        <ReactSwipe
          swipeOptions={{
            continuous: false,
            startSlide: index,
            callback: this.onSwiped,
            transitionEnd: i => this.setState({ index: i }),
          }}
          ref={ref => (this.reactSwipeEl = ref)}
        >
          {slides.map(slide => (
            <Slide key={slide.key}>
              {slide.raw ? (
                <React.Fragment>{slide.raw}</React.Fragment>
              ) : (
                <SlideWrapper>
                  <Text styles={Text.Styles.Bold24}>{slide.title}</Text>
                  {slide.graphic}
                  <Text
                    textAlign={Text.TextAlignments.Center}
                    styles={Text.Styles.Medium18}
                  >
                    {slide.description}
                  </Text>
                </SlideWrapper>
              )}
            </Slide>
          ))}
        </ReactSwipe>
        <Bottom>
          <StackChildren size={StackChildren.Sizes.Medium}>
            {currentSlide.showPagination && (
              <Pagination
                accessibilityLabel={'Pagination'}
                indicatorAccessibilityLabelPrefix={'Pagination'}
                count={count}
                selectedIndex={index}
              />
            )}
            {currentSlide.showReadyToDashButton && (
              <React.Fragment>
                {experiments.instant_dashing_v2 &&
                country !== COUNTRY_SHORTCODES.JP ? (
                  <LinkButton
                    type={Button.Types.PrimaryPill}
                    size={Button.Sizes.Large}
                    tag="a"
                    href={routes.webview.buildPath({
                      sub: INSTANT_DASH_SPLASH_SUB,
                    })}
                    onClick={() => {
                      trackInAppEducationNavigated({
                        deck,
                        button: SlideButtons.ReadyToDash,
                        action: EventActions.Clicked,
                      })
                      if (experiments.in_app_education_localstorage) {
                        SimpleStore.set(DD_READY_FIRST_DASH_TS, Date.now())
                      } else {
                        closeInAppEducation(uniqueLink)
                      }
                    }}
                  >
                    {s.readyForFirstDashButton()}
                  </LinkButton>
                ) : (
                  <Button
                    type={Button.Types.PrimaryPill}
                    size={Button.Sizes.Large}
                    tag="a"
                    href={
                      os === OsTypes.iOS
                        ? IOS_CLOSE_DEEPLINK
                        : ANDROID_CLOSE_DEEPLINK
                    }
                    onClick={() => {
                      trackInAppEducationNavigated({
                        deck,
                        button: SlideButtons.ReadyToDash,
                        action: EventActions.Clicked,
                      })
                      trackWebviewClosed()
                      if (experiments.in_app_education_localstorage) {
                        SimpleStore.set(DD_READY_FIRST_DASH_TS, Date.now())
                      } else {
                        closeInAppEducation(uniqueLink)
                      }
                    }}
                  >
                    {s.readyForFirstDashButton()}
                  </Button>
                )}
              </React.Fragment>
            )}
            {currentSlide.showNextButton && (
              <Button
                type={Button.Types.SecondaryPill}
                size={Button.Sizes.Large}
                onClick={() => {
                  this.clicked = true
                  this.reactSwipeEl.next()
                }}
              >
                {s.nextButton()}
              </Button>
            )}
            {currentSlide.showMoreQuestionsButton && (
              <Button
                type={Button.Types.SecondaryPill}
                size={Button.Sizes.Large}
                onClick={() => {
                  this.clicked = true
                  this.reactSwipeEl.next()
                }}
              >
                {s.moreQuestionsButton()}
              </Button>
            )}
          </StackChildren>
        </Bottom>
      </Wrapper>
    )
  }

  private onSwiped = (i: number) => {
    const { slides, deck, trackInAppEducationNavigated } = this.props
    const { index } = this.state

    const toSlide = i + 1
    trackInAppEducationNavigated({
      deck,
      slide: toSlide,
      title: slides[i].title,
      direction: toSlide > index ? Direction.Forward : Direction.Back,
      button: this.clicked ? SlideButtons.Next : undefined,
      action: this.clicked ? EventActions.Clicked : EventActions.Swiped,
    })
    if (this.clicked) {
      this.clicked = false
    }
  }
}

const mapStateToProps = state => ({
  application: state.application,
  experiments: state.experiments,
})

const mapDispatchToProps = {
  trackWebviewClosed: events.trackWebviewClosed,
  trackInAppEducationNavigated: events.trackInAppEducationNavigated,
  closeInAppEducation: actions.closeInAppEducation,
}

export default connect(mapStateToProps, mapDispatchToProps)(InAppEducation)
